import { useMutation } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IMetaAdsAuthResponse } from "../../features/Campaigns/interface/metaAds";

export const useMetaAdsAuth = () => {
  return useMutation<IMetaAdsAuthResponse, Error>({
    mutationFn: () => httpService.get<IMetaAdsAuthResponse>(API_CONFIG.path.metaAdsAuth),
  });
};
